import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  padding: 0;
  margin: 0 0 2rem;
`;
export const StepsRow = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  width: 100%;
`;
export const StepBar = styled.span `
  flex: 1 0 0;
  min-width: 0.1rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  background-color: ${({ complete }) => (complete
    ? 'var(--high-availability, #20a77f)'
    : 'var(--light-grey, #e7e6eb)')};
`;
export const StepLabel = styled.p `
  margin: 0;
  font-family: var(--body-font);
  font-size: 1.1rem;
  font-weight: 400;
  line-height: normal;
  color: var(--dark-grey, #444);
  white-space: nowrap;
`;
export default {
    Wrapper,
};
